import { createContext, type Dispatch, type SetStateAction } from 'react';
import { type GoodsType } from '@common/types/goods';
import { type ProductData } from '@common/types/workshopType';

interface WorkshopContextType {
  activeGoodsName: GoodsType | undefined;
  setActiveGoodsName: Dispatch<SetStateAction<GoodsType | undefined>>;
  activeGoods?: ProductData;
  incommingStorage: number;
  toAdd: number;
  producted: number;
  limit?: number;
  targetProduct?: GoodsType | null;
}

const WorkshopContext = createContext({} as WorkshopContextType);

export { WorkshopContext };
